// Enumerations
import { StylesRelativesUnitsEnum } from '@openbank/cf-ui-static-data';
const convertPxsToRems = ({ pixels, base = 16 }) => `${pixels / base}${StylesRelativesUnitsEnum.REM}`;
export { convertPxsToRems };
//# sourceMappingURL=media-query-units-conversions.utils.js.map